/* eslint-disable no-param-reassign */
import { isFunction } from 'lodash';

export default {
    data() {
        return {
            disabled: true,
            timer: null,
            count: '',
        };
    },
    methods: {
        end(cb) {
            clearInterval(this.timer);
            this.disabled = false;
            this.count = '';
            if (isFunction(cb)) cb();
        },
        countdown(time = 60, initTime = 60) {
            this.count = time;

            this.timer = setInterval(() => {
                time -= 1;
                this.count = time;
                if (time <= 0) {
                    this.end();
                    time = initTime;
                }
            }, 1000);
        },
    },
};
